import { NgModule } from '@angular/core';
import { CdkTableModule } from '@angular/cdk/table';

@NgModule({
    imports: [
        CdkTableModule
    ],
    exports: [
        CdkTableModule    
    ]
})
export class CdkModule { }